import React from 'react';

const AnimatedLoadingWave = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 600 100"
    version="1.1"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="nonzero"
      d="M 600 90 Q 500 -10 300 45 Q 145 90 0 15 L 0 0 L 600 0"
    >
      <animate
        attributeName="d"
        calcMode="spline"
        keyTimes="0; .5; 1"
        keySplines="0.25 0 0.25 1; 0.25 0 0.25 1"
        values="M 600 90 Q 500 -10 300 45 Q 145 90 0 15 L 0 0 L 600 0; M 600 45 Q 425 115 300 45 Q 175 -18 0 30 L 0 0 L 600 0; M 600 90 Q 500 -10 300 45 Q 145 90 0 15 L 0 0 L 600 0"
        repeatCount="indefinite"
        dur="18s"
      />
    </path>
  </svg>
);

export default AnimatedLoadingWave;
